import { TitleCell, TitleRow } from '../../../../components/ReusableComponents/Table'

const BillingTitleRow = () => (
  <TitleRow style={{ position: 'sticky', top: 70 }}>
    <TitleCell>Id</TitleCell>
    <TitleCell>Hotel name</TitleCell>
    <TitleCell>CSM</TitleCell>
    <TitleCell textAlign="center">Autopay</TitleCell>
    <TitleCell>Balance</TitleCell>
    <TitleCell>
      Late <br /> balance
    </TitleCell>
    <TitleCell>
      Service Block <br /> (Next 15 Days)
    </TitleCell>
    <TitleCell>
      Last payment <br /> amount
    </TitleCell>
    <TitleCell>
      Last payment <br /> date
    </TitleCell>
    <TitleCell>Notes</TitleCell>
  </TitleRow>
)

export default BillingTitleRow
